<template>
  <div>
    <ProfileReceivedReviewsSection :key="'Reviews'" v-if="!isDoctor" :type="''" :typeToShow="'all'" :changeTypeToShow="changeTypeToShow" />
    <template v-else>
      <ProfileReceivedReviewsSection
        :key="'In Person Visit'"
        :type="'In Person Visit'"
        v-if="typeToShow === 'all' || typeToShow === 'In Person Visit'"
        :typeToShow="typeToShow"
        :changeTypeToShow="changeTypeToShow"
      />
      <ProfileReceivedReviewsSection
        :key="'MyCircles'"
        :type="'MyCircles'"
        v-if="(typeToShow === 'all' || typeToShow === 'MyCircles') && ($route.path.includes('/view/') ? !viewUser.isDirectory : true)"
        :typeToShow="typeToShow"
        :changeTypeToShow="changeTypeToShow"
      />
      <ProfileReceivedReviewsSection
        :key="'Telemedicine'"
        :type="'Telemedicine'"
        v-if="typeToShow === 'all' || typeToShow === 'Telemedicine'"
        :typeToShow="typeToShow"
        :changeTypeToShow="changeTypeToShow"
      />
    </template>
  </div>
</template>

<script>
import ProfileReceivedReviewsSection from "./ProfileReceivedReviewsSection.vue"
export default {
  components: { ProfileReceivedReviewsSection },
  name: "ProfileReceivedReviews",
  data() {
    return { typeToShow: "all", isDoctor: false }
  },
  created() {
    console.warn("ProfileReceivedReviews.vue is created")
    if (this.viewUser) {
      if (["doctor", "physician", "hcp", "other", "ahcp", "ohcp"].includes(this.viewUser.role)) {
        this.typeToShow = "all"
        this.isDoctor = true
      }
    } else {
      if (["doctor", "physician", "hcp", "other", "ahcp", "ohcp"].includes(this.authUser.user.role)) {
        this.typeToShow = "all"
        this.isDoctor = true
      }
    }
  },
  mounted() {
    this.changeTypeToShow()
  },
  watch: {
    typeToShow(v, o) {
      console.log(o, "-> Parent typeToShow ->", v)
    },
  },
  methods: {
    changeTypeToShow() {
      if (!this.isDoctor) {
        this.typeToShow = "all"
        this.$route.params.type = "all"
        return
      }
      console.log("this.$route.params.type:", this.$route.params.type)
      switch (this.$route.params.type) {
        case "online":
          this.typeToShow = "Telemedicine"
          break
        case "inperson":
          this.typeToShow = "In Person Visit"
          break
        case "mycircles":
          this.typeToShow = "MyCircles"
          break
        default:
          this.typeToShow = "all"
          this.$route.params.type = "all"
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/home/reviews/ProfileReceivedReviews.vue